import React from 'react';
import styled from 'styled-components';

function WidgetCard({ data }: any) {
  return (
    <WidgetWrapper className='widget-card'>
      <div className='card-image-wrapper'>
        <img src={`${data?.imageUrl}`} className='card-image' />
      </div>
      <div className='card-detail'>
        <div className='fullName'>{data?.fullName}</div>
        <div className='position'>{data?.position}</div>
      </div>
    </WidgetWrapper>
  );
}
const WidgetWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  .card-image {
    border-radius: 50%;
    width: 100%;
    aspect-ratio: 1/1;
    overflow: hidden;
    object-fit: cover;
    &:hover {
      img {
        transform: scale(1.2);
      }
    }
  }
  .card-detail {
    width: 100%;
    position: relative;
    .fullName {
      text-align: center;
      color: #fff;
      font-size: 20px;
      font-weight: 600;
      @media (max-width: 767px) {
        font-size: 16px;
      }
      @media (max-width: 400px) {
        font-size: 14px;
      }
    }
    .position {
      text-align: center;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      @media (max-width: 767px) {
        font-size: 12px;
      }
    }
  }
`;
export default WidgetCard;
